import { render, staticRenderFns } from "./ArticleContent6.vue?vue&type=template&id=0887c96b&"
import script from "./ArticleContent6.vue?vue&type=script&lang=js&"
export * from "./ArticleContent6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Heading: require('/app/components/heading/Heading.vue').default,ListGuest: require('/app/components/list/ListGuest.vue').default})
